import { NewSupportTaskOutDto, NewSupportTaskInDto } from '../../../types/support-tasks.dto'

export const NEW_SUPPORT_TASK = 'NEW_SUPPORT_TASK'
export const NEW_SUPPORT_TASK_SUCCESS = 'NEW_SUPPORT_TASK_SUCCESS'
export const NEW_SUPPORT_TASK_ERROR = 'NEW_SUPPORT_TASK_ERROR'
export const RESET_NEW_SUPPORT_TASK = 'RESET_NEW_SUPPORT_TASK'

export interface NewSupportTask {
  type: typeof NEW_SUPPORT_TASK
  payload: NewSupportTaskOutDto
}

export interface NewSupportTaskSuccess {
  type: typeof NEW_SUPPORT_TASK_SUCCESS
  payload: NewSupportTaskInDto
}

export interface NewSupportTaskError {
  type: typeof NEW_SUPPORT_TASK_ERROR
  payload: string | boolean
}

export interface ResetNewSupportTask {
  type: typeof RESET_NEW_SUPPORT_TASK
  payload: null
}

export interface State {
  data: NewSupportTaskInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions = NewSupportTask | NewSupportTaskSuccess | NewSupportTaskError | ResetNewSupportTask
